import React from "react";

const Tiktok = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path fillRule="evenodd" clipRule="evenodd" d="M14 2C15.1046 2 16 2.89543 16 4C16 5.44733 17.03 6.6618 18.3984 6.93991C19.4808 7.15992 20.1799 8.21575 19.9599 9.29819C19.7399 10.3806 18.6841 11.0798 17.6016 10.8598C17.0406 10.7457 16.5037 10.5646 16 10.3252V16C16 19.3137 13.3137 22 10 22C6.68629 22 4 19.3137 4 16C4 13.2015 5.91407 10.8551 8.50148 10.1891C9.57119 9.91382 10.6616 10.5578 10.9369 11.6275C11.2122 12.6972 10.5682 13.7876 9.49852 14.0629C8.63547 14.285 8 15.0708 8 16C8 17.1046 8.89543 18 10 18C11.1046 18 12 17.1046 12 16V4C12 2.89543 12.8954 2 14 2Z"/>
    </svg>
)

export default Tiktok